module.exports = __webpack_public_path__ + "static/media/configuration.49c7b3a6.svg";